export default {
    data() {
        return {
            defaultColumns: [
                {
                    code: 'due_date',
                    label: this.$l10n.__('Date'),
                    sortKey: 'date',
                    width: 160,
                    minWidth: 160,
                    order: 0,
                    isVisible: true,
                    isMovable: false,
                    isDefault: true,
                },
                {
                    code: 'type',
                    label: this.$l10n.__('Type'),
                    sortKey: 'event',
                    order: 1,
                    isVisible: true,
                    isMovable: false,
                    isDefault: true,
                    width: 92,
                    minWidth: 92,
                },
                {
                    code: 'priority',
                    label: this.$l10n.__('Priorité'),
                    sortKey: 'priority',
                    order: 2,
                    isVisible: true,
                    isMovable: true,
                    width: 108,
                    minWidth: 108,
                },
                {
                    code: 'label',
                    label: this.$l10n.__('Label'),
                    sortKey: 'label',
                    order: 3,
                    isVisible: true,
                    isMovable: true,
                    width: 160,
                    minWidth: 160,
                },
                {
                    code: 'related',
                    label: this.$l10n.__('Liaisons'),
                    order: 4,
                    isVisible: true,
                    isMovable: true,
                    width: 320,
                    minWidth: 320,
                },
                {
                    code: 'description',
                    label: this.$t.__('common.labels.description'),
                    order: 5,
                    isVisible: false,
                    isMovable: true,
                    width: 480,
                    minWidth: 480,
                },
                {
                    code: 'title',
                    label: this.$l10n.__('Titre'),
                    order: 6,
                    isVisible: true,
                    isMovable: true,
                    width: 220,
                    minWidth: 220,
                },
                {
                    code: 'staff',
                    label: this.$l10n.__('Collaborateur(s)'),
                    order: 7,
                    isVisible: true,
                    isMovable: true,
                    width: 140,
                    minWidth: 140,
                },
            ],
        };
    },
};
